import { make } from 'vuex-pathify';
import axios from "axios";
import { triggerError } from "@/components/helpers/error-handler";

const timeout = 600000; //10 minutes

const getDefaultState = () => {
  return {
    endpoints: [],
    endpointsUpdated: null,
    endpoint: {},
    endpointRef: null,
    endpointUpdated: null,
    meter: {},
    meterRef: null,
    meterUpdated: null
  }
}

const state = getDefaultState();

const actions = {
  async getEndpointList({ state, commit }) {
    try {
      const time = new Date().getTime();

      if (state.endpointsUpdated && time - state.endpointsUpdated < timeout) {
        return true;
      }

      const { data } = await axios({
        url: process.env.VUE_APP_API_URL + "endpoints"
      });

      commit('store_endpoints', { data, time });

      return true;
    } catch (error) {
      return triggerError(error);
    }
  },
  async getEndpoint({ state, commit }, { endpointRef }) {
    try {
      const time = new Date().getTime();

      if (state.endpointUpdated && state.endpointRef === endpointRef && time - state.endpointUpdated < timeout) {
        return true;
      }

      const { data } = await axios({
        url: process.env.VUE_APP_API_URL + "endpoints/endpoint/" + endpointRef
      });

      commit('store_endpoint', { endpointRef, data, time });

      return true;
    } catch (error) {
      return triggerError(error);
    }
  },
  async getEndpointMeter({ state, commit }, { endpointRef, meterRef, force }) {
    try {
      const time = new Date().getTime();

      if (!force && state.meterUpdated && state.meterRef === meterRef && time - state.meterUpdated < timeout) {
        return true;
      }

      const { data } = await axios({
        url: process.env.VUE_APP_API_URL + "endpoints/endpoint/" + endpointRef + '/meter/' + meterRef
      });

      commit('store_meter', { meterRef, data, time });

      return true;
    } catch (error) {
      return triggerError(error);
    }
  },
  resetEndpointState ({ commit }) {
    commit('resetState')
  },
};

const mutations = {
  ...make.mutations(state),
  store_endpoints(state, {data, time}) {
    state.endpoints = data;
    state.endpointsUpdated = time;
  },
  store_endpoint(state, {endpointRef, data, time}) {
    state.endpoint = data;
    state.endpointRef = endpointRef;
    state.endpointUpdated = time;
  },
  store_meter(state, {meterRef, data, time}) {
    state.meter = data;
    state.meterRef = meterRef;
    state.meterUpdated = time;
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
};

const getters = {
  ...make.getters(state)
};

export const endpoints = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
